import { Experiment, ExperimentSlim, VariantType } from 'src/services';

export const getResumeWizardStep = (experiment: Experiment | ExperimentSlim): number => {
  if (!experiment.metric) {
    return 1;
  }

  if (!experiment.wizardSelection) {
    return 2;
  }

  const controlVariant = experiment.variants.find(variant => variant.type === VariantType.Control);
  const testVariant = experiment.variants.find(variant => variant.type === VariantType.Test);
  const hasVariantChanges = (testVariant?.versionChangesSummary?.totalChanges ?? 0) > 0;

  if (!hasVariantChanges) {
    return 3;
  }

  const hasSavedSplit =
    experiment.productionTrafficAllocation !== null &&
    experiment.productionTrafficAllocation !== undefined &&
    !!controlVariant &&
    !!testVariant;

  if (!hasSavedSplit) {
    return 4;
  }

  return 5;
};
